import React from 'react'

export const AboutUs = () => {
  return (


<section class="bg-[#fafad5] text-black">
<div class="mx-auto max-w-screen-xl px-4 py-12 sm:px-6 lg:px-8">
  <div class="mx-auto max-w-lg ">
    <h2 class="text-3xl font-bold sm:text-4xl text-center ">About Us</h2>
  </div>
  </div>
  <div className='flex max-w-screen-xl px-6 py-4'>
    <p>
    AI-Deep Learning Virtual Labs: AI Made Easy
    We at Sardar Patel Institute of Technology have started Virtual Lab which focuses on providing students with laboratory coursework material.
    AI-Deep Learning Virtual Labs: AI Made Easy will provide the students with the result of an experiment by one of the following methods (or possibly a combination).
    Modelling the physical phenomenon by a set of equations and carrying out simulations to yield the result of the particular experiment. 
    This can, at the best, provide an approximate version of the ‘real-world’ experiment. Providing measured data for virtual lab experiments 
    corresponding to the previously obtained measurements on an actual system. Remotely trigger an experiment in a real lab and provide the student with the experiment's result through the computer interface. 
    This would entail carrying out the actual lab experiment remotely.
    </p></div>
  </section>


  )
}
